



















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class IntersectWrapper extends Vue {
  @Prop({ type: String, default: "" }) minHeight!: string;

  notSupport = this.$common.utils.helper.notSupportIntersect();

  isIntersecting = false;

  get styles() {
    const styles: any = {};
    if (this.minHeight) {
      styles.minHeight = this.minHeight + "px";
    }
    return styles;
  }

  mounted() {
    if (this.notSupport) {
      this.isIntersecting = true;
    }
  }

  handleIntersect(_enteries, _observer, isIntersecting) {
    if (!this.notSupport) {
      this.isIntersecting = isIntersecting;
    }
  }
}
export default IntersectWrapper;
